export default class ChangeExcessAbstractServices {
  static getReferenceData() {
    logger.error(`ChangeExcess:: getReferenceData() not implemented`);
  }

  static getPremiumImpactReferenceData() {
    logger.error(`ChangeExcess:: getPremiumImpcactReferenceData() not implemented`);
  }

  static getCoverDetails() {
    logger.error(`ChangeExcess:: getCoverDetails() not implemented`);
  }
  
  static getPremiumOnNewExcess() {
    logger.error(`ChangeExcess:: getPremiumOnNewExcess() not implemented`);
  }

  static submitNewExcess() {
    logger.error(`ChangeExcess:: submitNewExcess() not implemented`);
  }
}